<script>
    import {createEventDispatcher} from "svelte";
    import {deepCopyByValue} from "../../../../../lib/utils";
    import {REQUEST_GENERAL} from "../../../../../lib/datatypes";
    import {
        NEXT_ACTION_STATES,
        DETAIL_MEANING_NO_ACTION_NEEDED,
        uiStateFromNextAction,
        logActionCompleted, app_state
    } from "../stores/misc";

    const dispatch = createEventDispatcher();

    export let type;
    export let owner_id;
    export let next_action;

    let ui_state = NEXT_ACTION_STATES.NEED_DETAILS;

    $: {
        ui_state = uiStateFromNextAction(next_action);
        // console.log('assessing next action details')
        // if(next_action.details === '') ui_state = NEXT_ACTION_STATES.NEED_DETAILS;
        // else if(next_action.details === DETAIL_MEANING_NO_ACTION_NEEDED) ui_state = NEXT_ACTION_STATES.NO_ACTION;
        // else if(next_action.waiting_for && next_action.details !== '') ui_state = NEXT_ACTION_STATES.WAITING_FOR;
        // else if(!next_action.waiting_for && next_action.details !== '') ui_state = NEXT_ACTION_STATES.ACTION_NEEDED;
    }

    let editing_next_action = {
        waiting_for: false,
        details: ''
    };
    const getEditingNextAction = async () => {
        editing_next_action = await deepCopyByValue(next_action);
    };
    const getEmptyEditingNextAction = () => {
        editing_next_action = {
            waiting_for: false,
            details: ''
        };
    };

    let is_editing = false;
    const startEditing = async () => {
        await getEditingNextAction();
        is_editing = true;
    };
    const cancelEditing = () => {
        is_editing = false;
    };
    const thingsHaveChanged = () => {
        getEmptyEditingNextAction();
        is_editing = true;
    };
    const noActionNeeded = () => {
        editing_next_action.details = DETAIL_MEANING_NO_ACTION_NEEDED;
        ui_state = NEXT_ACTION_STATES.NO_ACTION;
        saveEditing();
    };
    const actionDone = async () => {
        // TODO - what to do with a done action from a UI perspective?
        // Logging the fact that the action was completed
        await logActionCompleted($app_state.username, type, owner_id, await deepCopyByValue(next_action));
        // Warning the parent, so that it can reload the logs or whatever
        dispatch('logsChanged');
        thingsHaveChanged();
    };
    const saveEditing = () => {
        dispatch('nextActionUpdate', {new_next_action: editing_next_action});
        is_editing = false;
    };

</script>


{#if !is_editing}
<!-- VIEWING -->

    {#if ui_state === NEXT_ACTION_STATES.NEED_DETAILS}
    <!-- NONE -->
    <div class="rounded-md bg-red-50 my-4 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3 grow">
                <h3 class="text-sm font-medium text-red-800">What needs to happen next?</h3>
                <div class="mt-2 text-sm text-red-700 italic">
                    <p>A conversation, some research, an email or call? Make your best guess RIGHT NOW (your future self will thank you 😉)</p>
                </div>
                <div class="mt-4 flex flex-shrink-0 items-center justify-end space-x-2">
                    <button on:click|preventDefault={noActionNeeded} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Nothing..</button>
                    <button on:click|preventDefault={startEditing} type="submit" class="inline-flex items-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">Something!</button>
                </div>
            </div>
        </div>
    </div>
    {/if}

    {#if ui_state === NEXT_ACTION_STATES.WAITING_FOR}
    <!-- WAITING FOR -->
    <div class="rounded-md bg-yellow-50 my-4 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3 grow">
                <h3 class="text-sm text-yellow-700">Waiting For:</h3>
                <div class="mt-2 font-medium text-yellow-800">
                    <p>{@html next_action.details}</p>
                </div>
                <div class="mt-4 flex flex-shrink-0 items-center justify-end space-x-2">
                    <button on:click|preventDefault={thingsHaveChanged} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Things have changed</button>
                    <button on:click|preventDefault={actionDone} type="submit" class="inline-flex items-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600">Done</button>
                </div>
            </div>
        </div>
    </div>
    {/if}

    {#if ui_state === NEXT_ACTION_STATES.ACTION_NEEDED}
    <!-- ACTION NEEDED -->
    <div class="rounded-md bg-blue-50 my-4 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
                <h3 class="text-sm text-blue-700">Next Action:</h3>
                <div class="mt-2 font-medium text-blue-800">
                    <p>{@html next_action.details}</p>
                </div>
                <div class="mt-4 flex flex-shrink-0 items-center justify-end space-x-2">
                    <button on:click|preventDefault={thingsHaveChanged} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Things have changed</button>
                    <button on:click|preventDefault={actionDone} type="submit" class="inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Done</button>
                </div>
            </div>
        </div>
    </div>
    {/if}

    {#if ui_state === NEXT_ACTION_STATES.NO_ACTION}
    <!-- NO ACTION NEEDED -->
    <div class="rounded-md bg-green-50 my-4 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3 grow">
                <h3 class="text-sm font-medium text-green-800">No Action Needed</h3>
<!--                <div class="mt-2 text-sm text-green-700">-->
<!--                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid pariatur, ipsum similique veniam.</p>-->
<!--                </div>-->
                <div class="mt-4 flex flex-shrink-0 items-center justify-end space-x-2">
                    <button on:click|preventDefault={thingsHaveChanged} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Things have changed</button>
                </div>
            </div>
        </div>
    </div>
    {/if}

{:else}
<!-- EDITING -->

    <div class="rounded-md bg-red-50 my-4 p-4">
        <h3 class="text-sm font-medium text-red-600">What needs to happen next?</h3>

        <span class="mt-4 isolate inline-flex rounded-md shadow-sm">
            {#if !editing_next_action.waiting_for}
            <button type="button" on:click={() => editing_next_action.waiting_for = true} class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-400 hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">WAITING FOR</button>
            <button type="button" class="relative -ml-px inline-flex items-center rounded-r-md bg-red-600 px-3 py-2 text-sm font-semibold text-white ring-2 ring-inset ring-red-800 hover:bg-red-800 focus:z-10">OUR ACTION</button>
            {:else}
            <button type="button" class="relative inline-flex items-center rounded-l-md bg-red-600 px-3 py-2 text-sm font-semibold text-white ring-2 ring-inset ring-red-800 hover:bg-red-800 focus:z-10">WAITING FOR</button>
            <button type="button" on:click={() => editing_next_action.waiting_for = false} class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-400 hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">OUR ACTION</button>
            {/if}
        </span>
        <div class="mt-4">
            <label for="description" class="block text-sm font-medium text-red-600">Details</label>
            <p class="text-sm italic text-red-500">({@html REQUEST_GENERAL.NEXT_ACTION})</p>
            <div class="mt-3">
                <textarea bind:value={editing_next_action.details}
                          id="description" name="description" rows="4"
                          class="block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm"></textarea>
            </div>
        </div>

        <div class="flex justify-between pt-8">
            <button on:click={noActionNeeded}
                    type="button"
                    class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >No Action Needed</button>
            <div class="flex justify-end">
                <button on:click={cancelEditing}
                        type="button"
                        class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >Cancel</button>
                <button on:click={saveEditing}
                        type="submit"
                        class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >Save</button>
            </div>
        </div>
    </div>

{/if}

<style></style>